// free text links without a scheme would otherwise open as app routes
export const toExternalUrl = (link: string): string =>
  /^https?:\/\//i.test(link) ? link : `https://${link}`;
